<template>
  <header id="header">
    <div class="inner">
      <div class="tWrap">
        <div class="tRow">
            <div class="langCol tCell">
              <router-link :class="[list.class, index==changeRed ? 'active' : '']"  v-for="(list, index) in list" :to="list.to" :key="index" @click="reds(index)">{{list.txt}}</router-link>
            
              <!-- <a href="../en/">ENG</a> -->
              <!-- <a href="javascript:;" class="langTc active">中文</a> -->
            </div>
            <div class="logoCol tCell"><img src="../images/img-audi-logo.svg"></div>
          </div>
        </div>
    </div>
  </header>
</template>

<script>
import PubSub from 'pubsub-js'
export default {
  name: "Header",
  data() {
    return {
      changeRed: 1,
      screenWidth: document.body.clientWidth,
      list: [
        {id:0, to:'en', class:'',txt:'ENG'},
        {id:1, to:'cn', class:'langTc',txt:'中文'},
      ]
    };
  },
  mounted() {
    let that = this
    window.onresize = () => {
      return (() => {
          window.screenWidth = document.body.clientWidth   
          that.screenWidth = window.screenWidth
      })()
    }
    // that.getscreenWidth()
  },
  methods: {
    reds(index){
      this.changeRed = index;
    }
  },
  watch: {
    
  }
};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
.router-link-active {
  text-decoration: underline !important;
}
#header {
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 68px;
  font-family: "微軟正黑體","新細明體", 'AudiTypeScreen',Verdana,Geneva, sans-serif !important;   
  background: #fff;
  .inner {
    padding: 20px 0px;
    width: 92%;
    max-width: 1300px;
    margin: 0px auto;
  }
  .langCol {
    width: 50%;
    text-align: left;
    font-size: 0px;
    a {
      font-family: 'AudiTypeExtended',Verdana,Geneva,sans-serif !important;
      font-weight: 700;
      color: #000000;
      line-height: 1.35;
      font-size: 14px;
      text-decoration: none;
      padding-right: 10px;
      margin-right: 10px;
      border-right: 1px solid #000000;
      &.langTc {
        font-family: "微軟正黑體","新細明體", 'AudiTypeScreen',Verdana,Geneva, sans-serif !important;
        font-weight: 700;
        color: #000000;
        line-height: 1.35;
        font-size: 14px;
        padding-right: 0px;
        margin-right: 0px;
        border-right: none;
      }
      // &.active {
      //   text-decoration: underline;
      // }
    }
  }
  .logoCol {
    width: 50%;
    text-align: right;
    img {
      width: 85px;
      height: auto;
      vertical-align: middle;
    }
  }
}

@media screen and (max-width: 1024px) {
  #header .inner { 
    padding:20px 0px;
  }
  #header .langCol a {
    font-size:18px; 
    padding-right:10px; 
    margin-right: 10px;
  }
  #header .langCol a.langTc{
    font-size:18px;
  }
  #header .logoCol img {
    width:90px; 
    height: auto;
  }
}


@media screen and (max-width: 768px) {
  #header .inner { 
    padding:20px 0px;
  }
  #header .langCol a { 
    font-size:16px; 
    padding-right:10px; 
    margin-right: 10px; 
  }
  #header .langCol a.langTc { 
    font-size:16px;
  }
  #header .logoCol img { 
    width:81px; 
    height: auto;
  }
}


@media screen and (max-width: 500px) {
  #header {
    height: 48px;
  }
  #header .inner{ 
    padding: 10px 0px;
  }
  #header .langCol a { 
    font-size:16px; 
    padding-right:10px; 
    margin-right: 10px; 
  }
  #header .langCol a.langTc { 
    font-size:16px;
  }
  #header .logoCol img { 
    width:81px; 
    height: auto;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue